<template>
<div>
    <h1 class="subtitle">Pedido</h1>
    <div class="nj-card">
        <div class="nj-cols form c3">
            <InputForm text="Cliente">
                <input type="text" class="nj-text" v-model="filters.cli_search" @keyup.enter="buscar()">
            </InputForm>
            <InputForm text="Orden">
                <input type="text" class="nj-text" v-model="filters.ovt_id" @keyup.enter="buscar()">
            </InputForm>
            <InputForm text="Distrito">
                <select class="nj-select" v-model="filters.ubi_id" @change="buscar()">
                    <option></option>
                    <option v-for="item in distritos" :key="item.ubi_id" :value="item.ubi_id">{{ item.ubi_nombre }}</option>
                </select>
            </InputForm>
            <InputForm text="Estado">
                <select class="nj-select" v-model="filters.est_id" @change="buscar()">
                    <option></option>
                    <option v-for="item in estados" :key="item.est_id" :value="item.est_id">{{ item.est_nombre }}</option>
                </select>
            </InputForm>
            <InputForm text="Fecha inicio">
                <input type="text" class="nj-text" v-model="filters.ovt_fecha_inicio" @keyup.enter="buscar()">
            </InputForm>
            <InputForm text="Fecha fin">
                <input type="text" class="nj-text" v-model="filters.ovt_fecha_fin" @keyup.enter="buscar()">
            </InputForm>
        </div>
        <Buttons line>
            <Button label="Buscar" @click="buscar()" icon="search"></Button>
            <Button label="Nuevo" @click="popup({ componente: 'registrar', status: true })" icon="add" color="green"></Button>
        </Buttons>
    </div>
    <br>
    <div class="nj-card">
        <b-table :data="ordenes_venta" :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage" :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition"
            :default-sort-direction="defaultSortDirection" :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon" :sort-icon-size="sortIconSize" aria-next-label="Next page"
            aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
            <template slot-scope="props">
                <b-table-column label="ID" header-class="is-info">{{ props.row.ovt_id }}</b-table-column>
                <b-table-column label="DNI / RUC" header-class="is-info">{{ props.row.cli_documento_identidad }}</b-table-column>
                <b-table-column label="Cliente" header-class="is-info">{{ props.row.cli_nombre }}</b-table-column>
                <b-table-column label="Fecha venta" header-class="is-info">{{ props.row.ovt_fecha_venta }}</b-table-column>
                <b-table-column label="Total" header-class="is-info">{{ props.row.ovt_total }}</b-table-column>
                <b-table-column label="Estado" header-class="is-info">
                    <b-field>
                        <b-tag :class="tagEstado(props.row.est_id)">{{ props.row.est_nombre }}</b-tag>
                    </b-field>
                </b-table-column>
                <b-table-column label="Opciones" header-class="is-info">
                    <div class="nj-flx">
                        <Button type="icon" icon="info" title="Ver pedido venta" @click="popup({ componente: 'ver', status: true, ovt_id: props.row.ovt_id })"></Button>
                        <Button type="icon" icon="edit" title="Modificar" @click="popup({ componente: 'modificar', status: true })" :activationCode="true"></Button>
                    </div>
                </b-table-column>
            </template>
        </b-table>
    </div>
    <!-- popups -->
    <RegistrarOrdenVenta v-if="activarRegistrar" @close="popup($event)" />
    <ModificarOrdenVenta v-if="activarModificar" @close="popup($event)" :ovt_id="ovt_id" />
    <VerOrdenVenta v-if="activarVer" @close="popup($event)" :ovt_id="ovt_id" />
</div>
</template>

<script>
import { AppService, OrdenVentaService, ResponseStatus, UsuarioService } from "../../services"
import Arrays from "../../util/arrays"
import DateTime from "../../util/dateTime"
import Toast from "../../util/toast"
import { Button, Buttons, InputForm } from "../components"
import ModificarOrdenVenta from "./ModificarOrdenVenta"
import RegistrarOrdenVenta from "./RegistrarOrdenVenta"
import VerOrdenVenta from "./VerOrdenVenta.vue"

export default {
    name: "OrdenVenta",
    components: {
        RegistrarOrdenVenta,
        ModificarOrdenVenta,
        VerOrdenVenta,
        InputForm,
        Buttons,
        Button,
    },
    data() {
        return {
            filters: {
                cli_search: null,
                ovt_id: null,
                est_id: null,
                ubi_id: null,
            },
            ordenes_venta: [],
            estados: [],
            estados2: [],
            distritos: [],
            activarRegistrar: false,
            activarModificar: false,
            activarVer: false,
            ovt_id: null,
            isPaginated: true,
            isPaginationSimple: false,
            isPaginationRounded: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 10,
        }
    },
    methods: {
        buscar() {
            const request = {
                orden_venta: this.filters
            }
            OrdenVentaService
                .buscar(request)
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.ordenes_venta = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                })
        },
        activarOpcion(opcion) {
            return AppService.activarOpcion(opcion)
        },
        // aprobar() {
        //     Confirm.show({
        //         message: "¿Esta seguro de aprobar la orden de venta?",
        //         action: () => {
        //             // el tipo indica si es una aprobación por pago parcial o total de la orden
        //             OrdenVentaService.aprobar({
        //                 orden_venta: {
        //                     ovt_id: this.orden_venta.ovt_id,
        //                     coc_id: this.orden_venta.coc_id
        //                 }
        //             }).then(
        //                 response => {
        //                     if (ResponseStatus.isSuccess(response)) {
        //                         Toast.success(response.message)
        //                         this.cerrar(true)
        //                     }
        //                     else {
        //                         Toast.error(response.message)
        //                     }
        //                 },
        //                 error => {
        //                     Toast.error(error)
        //                     console.error(`error: `, error)
        //                 }
        //             )
        //         }
        //     })
        // },
        popup({
            componente,
            status,
            renderizar = false,
            ovt_id = null
        }) {
            switch (componente) {
                case "registrar":
                    this.activarRegistrar = status
                    break
                case "modificar":
                    this.activarModificar = status
                    break
                case "ver":
                    this.activarVer = status
                    break
                default: {
                    this.activarRegistrar = status
                    this.activarModificar = status
                    this.activarVer = status
                }
            }
            this.ovt_id = ovt_id
            if (renderizar) {
                this.buscar()
            }
        },
        tagEstado(id) {
            return this.estados.find((item) => item.est_id == id).styles
        },
    },
    beforeMount() {
        UsuarioService.obtenerOpciones()
    },
    mounted() {
        AppService.getData(["estados", "distritos"]).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.estados = Arrays.filter(response.data.estados, "est_codigo", ["creado", "pagado", "pago_parcial", "aprobado", "en_despacho", "completado"])
                    this.distritos = response.data.distritos
                    this.filters.ovt_fecha_inicio = DateTime.todayString({ days: -7 })
                    this.filters.ovt_fecha_fin = DateTime.todayString({ days: 2 })
                    this.buscar()
                }
                else {
                    Toast.error(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
    }
}
</script>

<style scoped></style>